export enum OrderLifeCycle {
  Form = "Form",
  Success = "Success",
}
